import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMyEstablishments } from '../services/assujettiService';

interface Establishment {
  id: string;
  hotel_name?: string;
  name: string;
  activity: string;
  category: string;
  star_category?: string;
  license_number: string;
  duration_months: number;
  expiry_date: string;
  status: string;
}

function statusBadge(status: string) {
  const s = status?.toLowerCase() || '';
  if (s.includes('valid')) return <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Valide</span>;
  if (s.includes('renouvel') || s === 'expiring_soon') return <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold bg-orange-100 text-orange-700">A renouveler</span>;
  return <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-700">Expiree</span>;
}

export default function V4EstablishmentsPage() {
  const [rows, setRows] = useState<Establishment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getMyEstablishments()
      .then((r: any) => setRows(Array.isArray(r) ? r : []))
      .catch((e: any) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="max-w-7xl mx-auto py-10 text-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" /><p className="mt-4 text-gray-500">Chargement...</p></div>;
  if (error) return <div className="max-w-7xl mx-auto py-10"><div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">{error}</div></div>;

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Mes etablissements</h1>
      <p className="text-gray-500 text-sm mb-6">Seuls les etablissements de votre compte sont visibles.</p>

      {rows.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">Aucun etablissement trouve.</div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {['Etablissement', 'Activite', 'Categorie', 'Licence', 'Duree', 'Expiration', 'Statut', 'Action'].map(h => (
                  <th key={h} className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {rows.map(r => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="px-5 py-4 text-sm font-medium text-gray-900">{r.name || r.hotel_name}</td>
                  <td className="px-5 py-4 text-sm text-gray-600">{r.activity || 'Hotel'}</td>
                  <td className="px-5 py-4 text-sm text-gray-600">{r.category || r.star_category || '-'}</td>
                  <td className="px-5 py-4 text-sm font-mono text-gray-600">{r.license_number || '-'}</td>
                  <td className="px-5 py-4 text-sm font-semibold">{r.duration_months ? `${r.duration_months} mois` : '-'}</td>
                  <td className="px-5 py-4 text-sm">{r.expiry_date ? new Date(r.expiry_date).toLocaleDateString('fr-FR') : '-'}</td>
                  <td className="px-5 py-4">{statusBadge(r.status)}</td>
                  <td className="px-5 py-4">
                    <Link to="/fpt/v4/licenses" className="text-blue-600 hover:text-blue-800 text-sm font-medium">Voir fiche</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
